<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="PayCcompaniest"
  [noChangeLabel]="true"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="columns && columns.length > 0">
    <div class="row col-sm-12">
      <div class="col-sm-4 treeview" *ngIf="formulaInfo && formulaInfo.length > 0">
        <kendo-treeview
          [nodes]="formulaInfo"
          textField="Title"
          [hasChildren]="hasChildren"
          [children]="fetchChildren"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          (selectionChange)="addItem($event, cinput, finput)">
        </kendo-treeview>
      </div>
      <div class="col-sm-8">
        <textarea
          [cols]="cols"
          [formControl]="formGroup.get('Condition')"
          [rows]="rows"
          [required]="true"
          (focus)="onChange('Condition')"
          #cinput
          placeholder="عبارت شرطی">
        </textarea>
        <textarea
          [cols]="cols"
          [formControl]="formGroup.get('Formula')"
          [rows]="rows"
          [required]="true"
          (focus)="onChange('Formula')"
          #finput
          placeholder="عبارت محاسباتی">
        </textarea>
      </div>
    </div>
    <div style="height: 25vmin">
      <kgrid
        #elementFormula
        [areaName]="areaName"
        label="فرمول عوامل"
        name="ElementFormula"
        [columns]="columns"
        [groupable]="false"
        [noToolBar]="true"
        [isHeaderSave]="true"
        [dataList]="filterFormula"
        (onDelete)="onDeleteElementFormula($event)"
        (onCreate)="onCreateElementFormula($event)"
        (onEdit)="onEditElementFormula($event)"
        (onSave)="onSave()"
        [paging]="false">
      </kgrid>
    </div>
  </ng-container>
</dynamic-form>
